var app = angular.module('leonardo');

var MergeUnitsController = function ($scope, $rootScope, $element, $state, $location) {
  $rootScope.loadReact({
    selector: '#merge-units',
    $element,
    component: window.reactComponent.MergeUnitsPropertyListPage,
    data: {
      breadcrumbs: [{ name: 'Utilities', icon: 'perm_contact_calendar' }, { name: $state.current.ncyBreadcrumb.label }],
      baseRoute: $state.current.name ? `#/${$state.current.name.replace('.', '/')}` : `#${$location.$$url}`,
      filters: {
        account: $state.params.account,
        portfolio: $state.params.portfolio,
        group: $state.params.group,
        property: $state.params.property
      },
      search: $state.params.search
    }
  });
};

app.controller('MergeUnitsController', ['$scope', '$rootScope', '$element', '$state', '$location', MergeUnitsController]);
